// Export all functions from contact service
export {
    createGoHighLevelContact,
    addTagsToContact,
    updateContact
} from './contact.service';

// Export all functions from opportunity service
export {
    createGoHighLevelOpportunity
} from './opportunity.service';